<div class="container-fluid">
  <div class="row">
    <div class="col-12 d-flex justify-content-center align-items-center p-4">
      <img class="logo" src="./../../../../assets/images/logo.png" />
    </div>
    <div class="col-12 my-4">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">Cuentas</h5>
          <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed eiusmod tempor incidunt ut
            labore et dolore magna aliqua.</p>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="row">
        <ng-container *ngFor="let cuenta of consolidado?.cuentas">
          <div class="col-4 mb-4">
            <div class="card card-info">
              <div class="card-body">
                <div class="card-title d-flex justify-content-between align-items-center">
                  <div class="card-title-content">
                    <h5 class="mb-1">{{cuenta?.alias}}</h5>
                    <span class="badge badge-success">{{cuenta?.codigo}}</span>
                  </div>
                </div>
                <ul class="list-group">
                  <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span class="list-title">Moneda</span>
                    <span class="list-value">{{cuenta?.moneda}}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span class="list-title">Disponible</span>
                    <span class="list-value">{{cuenta?.saldoDisponible | currency}}</span>
                  </li>
                  <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span class="list-title">Saldo Total</span>
                    <span class="list-value">{{cuenta?.saldo | currency}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="col-12 my-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Préstamos</h5>
            <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed eiusmod tempor incidunt ut
              labore et dolore magna aliqua.</p>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <ng-container *ngFor="let prestamo of consolidado?.prestamos">
            <div class="col-4">
              <div class="card card-info">
                <div class="card-body">
                  <div class="card-title d-flex justify-content-between align-items-center">
                    <div class="card-title-content">
                      <h5 class="mb-1">{{prestamo?.alias}}</h5>
                      <span class="badge badge-info">{{prestamo?.numeroPrestamo}}</span>
                    </div>
                  </div>
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <span class="list-title">Moneda</span>
                      <span class="list-value">{{prestamo?.moneda}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <span class="list-title">Saldo</span>
                      <span class="list-value">{{prestamo?.saldoActual | currency}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <span class="list-title">Valor Para Estar Al Día</span>
                      <span class="list-value">{{prestamo?.valorParaEstarAlDia | currency}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="col-12 my-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Déposito Plazo Fijo</h5>
            <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed eiusmod tempor incidunt ut
              labore et dolore magna aliqua.</p>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="row">
          <ng-container *ngFor="let deposito of consolidado?.depositosAPlazo">
            <div class="col-4">
              <div class="card card-info">
                <div class="card-body">
                  <div class="card-title d-flex justify-content-between align-items-center">
                    <div class="card-title-content">
                      <h5 class="mb-1">{{deposito?.tipoDeposito}}</h5>
                      <span class="badge badge-primary">{{deposito?.codigo}}</span>
                    </div>
                  </div>
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <span class="list-title">Moneda</span>
                      <span class="list-value">{{deposito?.moneda}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <span class="list-title">Capital</span>
                      <span class="list-value">{{deposito?.monto | currency}}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                      <span class="list-title">Fecha Vencimiento</span>
                      <span class="list-value">{{deposito?.fechaVencimiento | date: 'dd/MM/yyyy'}}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
